// extracted by mini-css-extract-plugin
export default {"option":"OptionSelect_option__91l6y","dadosUsuario":"OptionSelect_dadosUsuario__WFttK","focado":"OptionSelect_focado__perv5"};